import AppConstatnt from '../../config/app.constants';
class CoinPullReportController {
    /*@ngInject*/
    constructor(Auth, $state, $stateParams, DateUtil, User, UserService, RouteService, $translate, $q, SetupService, $rootScope) {
        this.$translate = $translate
        this.Auth = Auth
        this.$state = $state
        this.$stateParams = $stateParams
        this.DateUtil = DateUtil
        this.User = User
        this.RouteService = RouteService
        this.SetupService = SetupService
        this.$q = $q
        this.$rootScope = $rootScope;

        this.coinReportData = []
        this.routes = []
        this.totalValues = {}
        this.routeList = [];
        this.showReport = false;
        this.loading = false;

        this.model = {
            route: '',
            date: null,
            branch: this.$stateParams.branch || this.User.getUser().branchId,
            currentStats: 'route',
        };

        this.selected = {
            route: ''
        };

        this.stats = {
            route: 'route',
            branch: 'branch'
        }

        this.$rootScope.$broadcast('routeChange', '/app/coin-pull-report');
        this.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    }

    $onInit() {
        // this.$q.all([
        // this.RouteService.all(undefined, 0, 1000),
        this.SetupService.get(this.model.branch)
            // ])
            .then((data) => {
                // this.routes = data[0].results
                this.model.date = this.DateUtil.convertToDate(data.currentVaultDate || undefined);
                this.model.day = this.days[moment(this.model.date).day()];

                this.startMaxDate = {
                    minDate: this.model.date
                }
            })
            .catch((err) => {
                this.error = err.message
            })
        this.getAllRoutes();
    }

    getAllRoutes(searchKey, offset) {
        searchKey = searchKey || '';

        const routeSearchObj = {
            queryJSON: {
                rules: [{
                    field: 'branchId',
                    condition: '=',
                    data: this.model.branch
                },
                {
                    group: {
                        rules: [{
                            field: 'id',
                            condition: 'like',
                            data: '%' + searchKey + '%'
                        },
                        {
                            field: 'name',
                            condition: 'like',
                            data: '%' + searchKey + '%'
                        }
                        ],
                        operator: 'OR'
                    }
                }
                ],
                operator: 'AND'
            }
        }

        this.RouteService.all(routeSearchObj, offset, AppConstatnt.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalRecords = data.total;
                    this.routeList = this.mappingRouteDatas(data.results);
                } else {
                    const routes = this.mappingRouteDatas(data.results);
                    this.routeList = this.routeList.concat(routes);
                }
            })
    }

    mappingRouteDatas(routes) {
        return routes.map((route) => {
            return {
                Key: route.id + " | " + route.name,
                Value: route.id
            }
        });
    }

    print() {
        let obj = {
            coinReportData: this.coinReportData,
            model: this.model,
            doPrint: true
        }
        let url = this.$state.href('coinPullReportPrint')
        window.w = window.open(url, '_blank');
        window.w.printData = obj;
    }

    show() {
        this.loadData(this.selected.route ? this.selected.route.Value : null, moment(this.model.date).format('YYYY-MM-DD'))
    }

    loadData(route, date) {
        if (!route) {
            this.coinReportData = [];
            return;
        }

        this.loading = true;

        this
            .RouteService
            .coinPullReport(route, date)
            .then((data) => {

                data.forEach(function (row) {
                    let coins = angular.copy(row)
                    delete coins.address
                    delete coins.city
                    delete coins.fromLocationId
                    delete coins.name

                    row.coins = coins
                })

                this.coinReportData = data;

                let coinKeys = [];
                if (this.coinReportData.length > 0 && this.coinReportData[0].coins) {
                    const keys = Object.keys(this.coinReportData[0].coins);
                    coinKeys = keys;
                }

                this.coinReportData = data.map((branchReport) => {
                    let total = 0;

                    coinKeys.forEach((coinKey) => {
                        total += branchReport[coinKey];
                    });

                    branchReport.total = total;

                    return branchReport;
                })
                    .filter((branchReport) => {
                        return branchReport.total > 0;
                    });

                // console.log(this.coinReportData);
                this.showReport = true;
            })
            .catch((err) => {
                console.log('Some error', err)
            })
            .finally(() => {
                this.loading = false;
                this.model.route = this.selected.route.Value;
            });
    }

    tabSelection(selectedValue) {
        this.model.currentStats = selectedValue;
    }

    branchCoinPullReport() {
        this.loading = true;
        this.RouteService.branchCoinPullReport(this.model.branch, moment(this.model.date).format('YYYY-MM-DD'))
            .then((data) => {
                this.model.branchCoinReport = data.results;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    printBranchCoinReport() {
        let url = this.$state.href('branchCoinPullReportPrint');
        window.w = window.open(url, '_blank');
        window.w.printData = {
            results: this.model.branchCoinReport,
            branch: this.model.branch,
            day: this.model.day,
            date: this.model.date
        }
    }
}

export default CoinPullReportController;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/coin_pull_report.controller.js